<vw-toast-popup
  [isOpen]="isOpen"
  [title]="'profile.notification-preferences.title' | translate"
  [subtitle]="'profile.notification-preferences.description' | translate"
  (close)="onClose()"
>
  <div class="px-4 pb-6">
    @if (loading) {
      <div class="flex flex-col gap-3" aria-busy="true" data-testid="prefs-loading">
        @for (i of [0, 1, 2]; track i) {
          <vw-skeleton-loader [width]="'100%'" [height]="'56px'" [borderRadius]="'1rem'"></vw-skeleton-loader>
        }
      </div>
    } @else if (loadError) {
      <vw-error-state [compact]="true" (retry)="load()"></vw-error-state>
    } @else {
      <!-- Une carte par sorte d'alerte : le nom et l'interrupteur d'abord ; le
           « comment » (téléphone, lesquelles) n'apparaît que si la sorte est
           active, pour ne pas répéter cinq fois des réglages éteints. -->
      <div class="flex flex-col gap-3">
        @for (p of preferences; track p.category) {
          <section class="overflow-hidden rounded-card border border-vw-line bg-vw-surface" data-testid="prefs-category"
            [attr.data-category]="p.category">
            <div class="flex min-h-14 items-center gap-1 pl-4 pr-1">
              <h3 class="min-w-0 flex-1 text-body font-semibold text-vw-ink" [id]="'prefs-' + p.category">
                {{ 'profile.notification-preferences.categories.' + p.category | translate }}
              </h3>
              <!-- Aide : à quoi ressemble une alerte de ce type. Cible de 44 px. -->
              <button type="button" data-testid="prefs-help"
                class="flex h-target w-target shrink-0 items-center justify-center rounded-pill text-vw-muted active:bg-vw-surface-sunk"
                [class.text-vw-primary]="expanded === p.category"
                [attr.aria-expanded]="expanded === p.category"
                [attr.aria-label]="'profile.notification-preferences.what-is-it' | translate"
                (click)="toggleInfo(p.category)">
                <vw-info-icon class="block h-5 w-5" />
              </button>
              <vw-switch data-testid="prefs-enabled" [(checked)]="p.isEnabled"
                [ariaLabel]="'profile.notification-preferences.categories.' + p.category | translate"></vw-switch>
            </div>

            @if (expanded === p.category) {
              <div class="mx-4 mb-3 rounded-field bg-vw-surface-sunk px-3 py-2">
                <p class="text-body-s text-vw-body">
                  {{ 'profile.notification-preferences.help.' + p.category + '.what' | translate }}
                </p>
                <p class="mt-1 text-body-s italic text-vw-muted">
                  {{ 'profile.notification-preferences.help.' + p.category + '.example' | translate }}
                </p>
              </div>
            }

            @if (p.isEnabled) {
              <div class="border-t border-vw-line">
                <div class="flex min-h-14 items-center gap-3 pl-4 pr-1">
                  <span class="min-w-0 flex-1 text-body-s text-vw-body">
                    {{ 'profile.notification-preferences.push-enabled' | translate }}
                  </span>
                  <vw-switch data-testid="prefs-push" [(checked)]="p.pushEnabled"
                    [ariaLabel]="'profile.notification-preferences.push-enabled' | translate"></vw-switch>
                </div>
                @if (p.pushEnabled) {
                  <!-- Le niveau tient sur une ligne (valeur à droite, comme les réglages
                     d'un téléphone) ; les trois choix ne se déplient qu'au toucher. -->
                  <button type="button" data-testid="prefs-severity-row"
                    class="flex min-h-14 w-full items-center gap-3 border-t border-vw-line pl-4 pr-3 text-left active:bg-vw-surface-sunk"
                    [attr.aria-expanded]="severityOpen === p.category" (click)="toggleSeverity(p.category)">
                    <span class="min-w-0 flex-1 text-body-s text-vw-body">{{ 'profile.notification-preferences.min-severity' | translate }}</span>
                    <span class="text-body-s font-semibold text-vw-primary-ink" data-testid="prefs-severity-value">
                      {{ severityLabel(p.minPushSeverity) | translate }}
                    </span>
                    <vw-chevron-right-icon class="block h-5 w-5 shrink-0 text-vw-icon-idle transition-transform"
                      [class.rotate-90]="severityOpen === p.category" aria-hidden="true" />
                  </button>
                  @if (severityOpen === p.category) {
                    <div class="px-4 pb-3" data-testid="prefs-severity">
                      <vw-choice-selector variant="list" [options]="severityOptions" [value]="p.minPushSeverity"
                        (valueChange)="chooseSeverity(p, $event)"
                        [ariaLabel]="'profile.notification-preferences.min-severity' | translate"></vw-choice-selector>
                    </div>
                  }
                }
              </div>
            }
          </section>
        }
      </div>
      <!-- Le résumé du matin n'est pas une catégorie : le rappeler évite de
           chercher un réglage qui n'existe pas. -->
      <p class="mt-4 text-body-s text-vw-muted">
        {{ 'profile.notification-preferences.footnote' | translate }}
      </p>
      @if (saveFailed) {
        <p role="alert" class="mt-4 text-body-s text-vw-danger" data-testid="prefs-save-error">
          {{ 'errors.businessException' | translate }}
        </p>
      }
      <div class="mt-4">
        <vw-button
          data-testid="prefs-save"
          [label]="'profile.notification-preferences.save' | translate"
          look="primary"
          [loading]="saving"
          (onClick)="save()"
          customClass="w-full"
        ></vw-button>
      </div>
    }
  </div>
</vw-toast-popup>
